import React from 'react';
import Helmet from 'react-helmet';
import { DOMAIN } from "src/constants";

const SEOPrevNextHelmet = ({ data }) => {
  const { numberOfPages, currentPage, prevPath, nextPath } = data;
  return (
    <Helmet>
      {currentPage < numberOfPages && (
        <link rel="next" href={DOMAIN + nextPath}></link>
      )}
      {currentPage > 1 && <link rel="prev" href={DOMAIN + prevPath}></link>}
    </Helmet>
  );
};
export default SEOPrevNextHelmet;
